import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  FETCH_CHECK_PAYMENT: "FETCH_CHECK_PAYMENT"
};

const fetchCheckPayment = async (state, checkpayment) => {
  state = {
    ...state,
    isStatus: checkpayment.status,
    expireToken: sanitizeExpire({
      status: checkpayment.status,
      data: checkpayment.data,
      name: "checkpaymentobj"
    }),
    data: sanitizeData({
      status: checkpayment.status,
      data: checkpayment.data,
      name: "checkpaymentobj"
    })
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CHECK_PAYMENT:
      return fetchCheckPayment(state, action.checkpayment);
    default:
      return state;
  }
};

const checkpayment = {
  init,
  actionTypes,
  reducer
};

export default checkpayment;
